/**
 * Created by Ning Jiang on 11/23/2016.
 */

import {IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import {BetWinMode} from "@nolimitcity/slot-game/bin/core/gametype/BetWinMode";
import {SpinMode} from "@nolimitcity/slot-game/bin/core/gametype/SpinMode";
import {ISymbolStateConfig, ISymbolStates} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {LayerScaleOption} from "@nolimitcity/slot-game/bin/core/stage/LayerScaleOption";
import {IDeviceDependentConfig} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import {IWinRatios, WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {Back, Ease} from "gsap";
import {TeslaSymbols} from "../config/TeslaSymbols";
import {ITeslaLayersConfig} from "./stage/ITeslaLayersConfig";


interface ITeslaSymbolStates extends ISymbolStates {
    noWin:ISymbolStateConfig;
    attention:ISymbolStateConfig;
}


export class TeslaGameConfig implements IGameConfig {

    public static instance:TeslaGameConfig = new TeslaGameConfig();

    BROWSER_FPS:number = 30;

    public static STAGE_WIDTH_LANDSCAPE:number = 1280;
    public static STAGE_HEIGHT_LANDSCAPE:number = 720;

    public static STAGE_WIDTH_PORTRAIT:number = 720;
    public static STAGE_HEIGHT_PORTRAIT:number = 1074;

    get GAME_WIDTH():number {
        return 1280;
        //return StageManager.orientation == Orientation.PORTRAIT ? TeslaGameConfig.STAGE_WIDTH_PORTRAIT : TeslaGameConfig.STAGE_WIDTH_LANDSCAPE;
    }

    get GAME_HEIGHT():number {
        return 720;
        //return StageManager.orientation == Orientation.PORTRAIT ? TeslaGameConfig.STAGE_HEIGHT_PORTRAIT : TeslaGameConfig.STAGE_HEIGHT_LANDSCAPE;
    }


    get REEL_AREA_POS_X():number {
        return 315;
        //return StageManager.orientation == Orientation.PORTRAIT ? 35 : 315;
    }

    get REEL_AREA_POS_Y():number {
        return 100;
        //return StageManager.orientation == Orientation.PORTRAIT ? 120 : 100;
    }


    get DEFAULT_LAYER_SCALE_OPTION():IDeviceDependentConfig<LayerScaleOption> {
        return {
            desktop : {
                landscape : LayerScaleOption.FIT_WINDOW
            },
            mobile : {
                landscape : LayerScaleOption.FIT_WINDOW,
                portrait : LayerScaleOption.REELS_FIT_STAGE
            }
        };
    }


    LAYERS:ITeslaLayersConfig = {
        BACKGROUND : {name : "background"},
        BACKGROUND_OVERLAY : {name : "backgroundOverlay"},
        REEL_BACKGROUND : {name : "reelBackground"},
        BET_LINES : {name : "betLines"},
        REEL_ATTENTION : {name : "reelAttention"},
        SYMBOLS_FRAME : {name : "SYMBOLS_FRAME"},
        SYMBOLS : {name : "symbols"},
        SYMBOLS_FRAME_FOREGROUND : {name : "SYMBOLS_FRAME_FOREGROUND"},


        BONUS_OVERLAY : {name : "BONUS_OVERLAY"},
        FREE_SPIN : {name : "freespin"},

        BIG_WIN : {name : "bigWin"},
        FS_SCREEN : {name : "FS_SCREEN", customOptions : {placement : {x : 0.5, y : 0.5}}},

        INTRO : {name : "INTRO", customOptions : {placement : {x : 0.5, y : 0.5}}},
        DEBUG_BACKGROUND : {name : "debugBackground"},
        DEBUG_OVERLAY : {name : "debugOverlay", scaleOption : LayerScaleOption.NONE},
    };

    BET_WIN_MODE:BetWinMode = BetWinMode.BET_LINE;
    SPIN_MODE:SpinMode = SpinMode.SPIN;

    REEL_AREA_WIDTH:number = 650;
    REEL_AREA_HEIGHT:number = 390;


    REELS_NUM:number = 5;
    REEL_DISPLAY_POSITIONS:[number, number][] = [[65, 0], [195, 0], [325, 0], [455, 0], [585, 0]];
    SYMBOLS_NUM_IN_REEL:[number, number, number, number, number] = [0, 1, 3, 1, 0];


    SYMBOL_STATES:ITeslaSymbolStates = {
        hidden : {
            prio : 0,
            keyword : "hidden",
        },
        spin : {
            prio : 1,
            keyword : "spin",
            offsetGetter : TeslaSymbols.offset
        },
        normal : {
            prio : 2,
            keyword : "normal",
            offsetGetter : TeslaSymbols.offset
        },
        noWin : {
            prio : 3,
            keyword : "noWin",
            offsetGetter : TeslaSymbols.offset
        },
        attention : {
            prio : 4,
            keyword : "attention",
            offsetGetter : TeslaSymbols.offset
        },
        win : {
            prio : 5,
            keyword : "win",
            texturesCreator : (symName:string, stateKey:string) => {
                let textures:PIXI.Texture[] = GameResources.getTextures(symName + "_" + stateKey);
                if(symName == TeslaSymbols.B || symName == TeslaSymbols.B2 || TeslaSymbols.L1) {
                    return textures;
                }
                let normalTexture = GameResources.getTextures(symName + "_normal")[0];
                textures.unshift(normalTexture);
                textures.push(normalTexture);
                return textures;
            },
            offsetGetter : TeslaSymbols.offset
        }

    };

    SYMBOL_WIDTH:number = 130;
    SYMBOL_HEIGHT:number = 130;
    SYMBOL_BOTTOM_PADDING:number = 0;


    REEL_SPIN_TIME:number = 1.3;
    REEL_FAST_SPIN_SPIN_TIME:number = 0.2;
    MIN_STOPPING_TIME:number = 1.6;
    REEL_SPIN_START_SYMBOL_CHANGE_TO_SPIN_STATE_DURATION:number = 0.2;
    REEL_SPIN_START_SYMBOL_CHANGE_TO_SPIN_STATE_DELAY:number = 0.3;
    REEL_SPIN_START_EASE:Ease = Back.easeIn.config(4);
    REEL_SPIN_STOP_SYMBOL_CHANGE_FROM_SPIN_STATE_DURATION:number = 0.2;
    REEL_SPIN_STOP_SYMBOL_CHANGE_FROM_SPIN_STATE_DELAY:number = 0;
    REEL_SPIN_STOP_ELASTIC_CONFIG:[number, number] = [1.5, 0.75];
    REEL_SPIN_QUICK_STOP_ELASTIC_CONFIG:[number, number] = [1.2, 0.75];

    REEL_SPIN_START_SPEED:number = 0.3;
    REEL_SPIN_SPIN_SPEED:number = 0.04;
    REEL_NEAR_WIN_SPIN_SPEED:number = 0.03;
    REEL_SPIN_STOP_SPEED:number[] = [0.5, 0.5, 0.5, 0.5, 0.5];
    REEL_SPIN_QUICK_STOP_SPEED:number = 0.5;

    REEL_STOP_DELAY:number[] = [0.3, 0.3, 0.25, 0.2, 0.15];
    REEL_QUICK_STOP_DELAY:number = 0.1;
    REEL_NEAR_WIN_STOP_DELAY:number[] = [0, 0, 2, 2.5, 3];

    REEL_SETS:any = {
        "BASE_REELSET" : [
            ["M3", "L2", "L3", "M3", "L4", "L5", "L3", "M4", "L5", "L4", "L1", "M3", "L3", "L2", "L1", "L5", "M2", "L2", "L1", "L3", "M4", "L1", "L3", "M4", "L1", "L5", "L4", "M1", "L3", "L1", "M3", "L5", "L3", "L4", "L1", "L5", "L3", "L1", "S", "L4", "L3", "L5", "L1", "L4", "L3", "L2", "M4", "L5", "M2", "M1", "L5", "L3", "M2", "L5", "S", "L4", "L3", "S", "M1", "M3", "L4", "M4", "M2", "L3", "L5", "L1", "L2", "M2", "L5", "L3", "L2", "L4", "L3", "S", "M3", "L3", "L5", "L4", "S", "L2", "L3", "L1", "M4", "L3", "M3", "L5", "L3", "L1", "M4", "L2", "L4", "M3", "L5", "L1", "L2", "M3", "L3", "M4", "L1", "L4", "L5", "L3", "M2", "M4", "L5", "L2", "L4", "L1", "M2", "L5", "L4", "S", "L5", "L3", "L4", "L5", "L2", "M3", "M2", "L2", "L3", "L4", "L1", "L3", "M3", "L4", "M2", "L5", "L2", "L1", "L5", "L4", "M1", "L5", "M4", "L3", "L2", "M3", "L1", "L3", "L4", "M4", "L1", "L3", "L2", "L4", "M4", "L3", "L4", "L1"],
            ["M1", "L4", "M4", "L2", "M3", "S", "L2", "W", "M2", "L5", "L1", "M2", "L2", "M4", "L5", "L4", "L2", "M4", "L4", "L2", "M1", "M4", "L4", "L5", "L2", "L4", "L3", "L2", "L1", "M4", "M2", "L2", "L1", "L4", "M2", "L5", "M1", "M4", "L5", "L4", "L2", "W", "M2", "L4", "L2", "S", "L5", "M1", "L2", "L3", "L1", "L2", "L3", "L5", "L2", "L3", "L5", "M4", "S", "L2", "L4", "M2", "M4", "M3", "L4", "L3", "L2", "M4", "L5", "L2", "L4", "L3", "L2", "M4", "M1", "L1", "L2", "L3", "L1", "L2", "M2", "L4", "L2", "L3", "M2", "L2", "L1", "M4", "L3", "L4", "M1", "M4", "L4", "L5", "M1", "L2", "L5", "M3", "L3", "L1", "L2", "L5", "M1", "M4", "L2", "S", "L4", "L2", "W", "M3", "L5", "L4", "L1", "L2", "M3", "L5", "M4", "L3", "M3", "M1", "M2", "L4", "L2", "M3", "L1", "L2", "M1", "S", "L4", "L5", "M2", "S", "L2", "L3", "W", "M4", "L4", "M2", "L5", "L2", "M4", "L5", "L1", "M2", "M4", "L3", "L2", "L4", "L5", "M4"],
            ["L4", "L3", "M4", "L4", "L2", "L3", "M1", "L4", "L1", "L3", "L5", "L2", "M1", "L4", "L2", "L1", "L3", "L4", "L1", "L2", "L3", "L5", "W", "L3", "L4", "L2", "L1", "L4", "L2", "L1", "L5", "L3", "L1", "L2", "L4", "M2", "L2", "M3", "L4", "W", "L3", "L1", "L5", "L3", "S", "L2", "L5", "S", "L3", "M4", "L4", "M1", "L3", "L2", "L1", "L5", "L3", "M4", "L4", "L5", "M4", "L2", "L4", "L3", "M4", "L2", "S", "M4", "W", "L1", "L5", "L2", "L4", "M2", "M4", "M3", "L3", "L4", "M4", "L3", "L5", "L4", "M1", "L3", "L2", "M3", "L1", "L4", "M1", "M4", "L1", "L2", "L3", "L5", "M1", "M3", "L4", "L1", "M3", "L5", "L3", "M3", "M1", "L1", "L4", "L5", "M2", "L1", "M3", "L2", "L5", "L4", "L3", "M3", "L1", "M4", "L2", "L4", "L3", "L5", "M3", "L4", "M2", "L1", "L4", "M3", "L1", "L3", "L5", "M2", "W", "M4", "L4", "M3", "L3", "W", "L5", "M4", "M2", "L1", "L3", "L4", "M3", "L1", "L3", "L4", "L1", "M4", "M3", "W"],
            ["L1", "L2", "L5", "M4", "L1", "L2", "M4", "L4", "L3", "M1", "M4", "L3", "L1", "M1", "M2", "L4", "L3", "M1", "L1", "S", "L2", "L1", "L4", "L2", "L1", "M3", "L2", "L3", "L5", "M4", "L1", "L2", "L5", "L4", "L1", "M3", "S", "L1", "L4", "M1", "L1", "W", "M4", "L2", "M3", "M4", "L2", "S", "L1", "M1", "W", "M4", "L1", "L5", "L2", "M4", "M2", "M3", "L1", "L2", "M4", "L5", "L2", "M4", "L4", "S", "L2", "W", "M2", "L5", "L2", "L1", "L3", "L2", "M1", "L3", "L1", "L4", "M3", "S", "L3", "M3", "M4", "L1", "L5", "L2", "L4", "L5", "L2", "L4", "M1", "L1", "M3", "S", "L3", "M1", "L5", "L2", "W", "L4", "L3", "L2", "L4", "S", "M3", "M4", "L2", "L4", "L3", "L1", "L2", "L5", "L1", "L2", "L5", "L4", "L1", "L3", "L2", "L1", "L4", "L3", "L2", "M3", "L4", "L1", "L5", "L4", "L1", "L2", "L3", "L4", "L2", "M1", "W", "L1", "L3", "L5", "L4", "L1", "L2", "L5", "M3", "L1", "L2", "L3", "L4", "L1", "L5", "L4"],
            ["M2", "L4", "B", "M3", "L4", "L3", "L2", "L5", "L1", "L4", "L5", "L1", "M1", "L4", "L3", "M4", "L2", "L5", "M4", "L3", "L5", "L4", "L2", "L1", "L4", "M2", "M3", "L5", "L4", "M3", "B", "M4", "S", "M1", "B", "L3", "L2", "L4", "M2", "L2", "L5", "M4", "L1", "L2", "L3", "L5", "L2", "L3", "M4", "L1", "L4", "L3", "M2", "L5", "M4", "L1", "L5", "L3", "L2", "M4", "L3", "M1", "L4", "L3", "M1", "L5", "M4", "L4", "M1", "L3", "L2", "S", "M3", "M4", "M2", "L4", "L5", "L3", "M4", "L4", "M1", "L1", "L2", "M2", "L1", "L5", "M3", "M1", "B", "L5", "M4", "L4", "L3", "L5", "M4", "L4", "L2", "M1", "L1", "L4", "L5", "L3", "L2", "M4", "S", "L3", "M4", "L2", "L5", "L3", "L4", "S", "L5", "L2", "S", "L5", "L2", "M4", "L5", "L2", "S", "M4", "L1", "L3", "L4", "M4", "L3", "L5", "M1", "M2", "L3", "L4", "M2", "L1", "L2", "L4", "L3", "L5", "S", "M4", "M3", "L4", "M1", "L1", "S", "M4", "L2", "L3", "L4", "L5"]
        ],
        "FREESPIN_REELSET" : [
            ["L4", "L3", "L2", "M4", "L5", "L1", "L3", "L2", "L1", "M4", "L3", "L1", "M4", "L4", "L3", "L1", "M2", "L5", "L3", "L1", "M4", "L3", "M1", "L2", "L5", "L1", "L2", "L5", "L3", "L4", "L2", "L3", "L4", "L1", "L2", "M4", "M3", "L3", "L4", "L5", "M4", "L1", "L2", "M2", "L4", "L1", "L5", "L3", "L1", "L5", "M4", "L1", "L3", "L4", "M4", "L3", "L1", "M4", "L3", "L5", "M2", "L3", "L4", "L5", "L3", "L1", "L5", "L3", "L4", "M3", "L1", "L3", "M4", "L5", "L4", "L2", "L1", "L3", "L5", "L2", "M3", "L3", "L1", "L2", "L5", "M3", "L3", "L4", "M2", "L1", "L3", "M4", "L2", "L1", "L3", "L2", "M4", "L1", "L3", "L2", "L5", "M1", "L4", "L3", "M4", "L1", "L2", "L3", "L1", "M4", "L4", "L3", "L5", "L1", "L2", "L5", "L4", "L1", "L5", "L4", "L1", "M3", "M4", "L1", "L5", "L3", "M3", "L5", "M2", "L3", "L1", "M4", "L5", "L1", "L4", "M2", "L5", "L3", "L1", "L5", "L3", "M4", "L1", "L5", "M1", "L2", "L5", "L4", "L3", "L1"],
            ["L2", "L4", "M1", "L2", "L4", "M4", "L2", "L4", "W2", "M4", "L5", "L2", "M4", "M3", "L4", "L2", "L1", "L4", "L2", "M3", "M4", "L5", "M2", "L2", "W2", "M4", "L2", "L5", "M2", "L3", "L5", "L2", "L4", "M2", "L3", "L4", "W2", "M3", "L2", "L4", "M4", "L3", "L4", "L2", "L3", "L1", "L4", "L5", "M3", "M4", "L2", "W2", "L5", "M4", "L2", "L5", "W2", "L4", "L2", "M3", "M4", "L4", "W2", "M4", "L2", "L4", "L3", "L2", "L4", "L5", "L2", "L3", "L1", "L4", "L2", "L5", "L3", "M2", "M4", "W2", "L4", "L2", "L1", "L4", "W2", "L2", "L4", "L1", "M1", "M3", "M2", "L2", "L4", "W2", "L1", "L2", "L4", "W2", "M4", "L4", "L2", "W2", "L4", "M4", "L3", "L4", "W2", "L2", "M4", "L3", "L2", "L4", "L3", "M3", "M1", "W2", "L4", "M4", "L2", "M2", "L4", "L1", "M2", "L2", "L4", "L1", "L2", "L4", "L1", "L2", "L4", "M2", "M4", "L4", "L3", "M4", "M2", "L4", "L2", "M4", "L4", "L5", "W2", "L4", "M1", "L2", "L4", "L3", "M2", "M3"],
            ["M3", "L4", "L3", "L1", "L4", "L3", "L1", "L2", "L4", "L3", "L2", "L5", "M4", "L1", "L2", "L3", "L4", "L2", "M4", "M1", "L3", "L1", "L2", "L3", "M4", "L1", "L2", "M4", "W2", "L1", "L3", "M1", "M3", "L2", "L4", "L1", "M1", "L4", "M4", "L1", "L3", "L4", "M1", "L5", "L4", "L2", "L5", "W2", "L4", "L3", "L1", "L4", "W2", "L2", "M3", "L1", "L3", "M4", "L1", "L2", "M4", "L3", "M3", "L2", "L3", "L5", "L2", "M2", "L4", "L3", "L1", "L4", "M4", "M3", "W2", "L5", "L4", "L3", "M4", "W2", "L2", "L4", "M3", "L3", "L4", "L1", "W2", "L2", "M2", "L3", "L1", "M3", "L2", "M4", "M1", "L1", "L2", "M4", "L3", "L5", "L4", "M2", "L5", "L3", "L1", "W2", "L3", "L2", "L1", "W2", "L2", "M3", "L3", "L2", "M4", "M3", "L5", "L2", "L1", "L4", "L2", "L3", "W2", "L4", "L2", "L3", "L4", "M4", "L3", "L4", "M4", "L1", "W2", "M1", "L4", "L1", "W2", "L3", "L5", "L4", "W2", "L3", "L5", "L1", "M3", "L3", "L4", "L5", "W2", "L2"],
            ["M3", "L2", "L3", "L4", "L5", "L1", "L3", "L2", "M4", "L1", "L2", "L4", "L1", "L2", "W2", "L4", "L2", "W2", "L1", "L3", "L4", "L5", "M3", "L4", "M2", "M4", "L2", "L5", "L4", "L1", "L3", "L5", "L2", "L3", "M2", "L1", "M4", "L4", "W2", "M3", "L3", "L5", "L4", "L1", "L5", "L3", "M4", "L2", "L5", "L3", "M3", "L1", "L2", "L3", "L1", "L5", "L4", "L2", "L3", "L4", "M3", "L5", "L2", "L4", "L3", "M4", "L4", "L1", "M4", "L4", "M3", "L3", "L4", "L5", "L3", "L2", "L4", "M2", "M3", "L3", "W2", "L1", "L5", "L2", "M4", "L5", "L3", "M3", "M4", "W2", "L3", "M3", "L5", "W2", "M4", "L4", "L2", "L5", "M4", "L3", "W2", "L5", "L3", "L1", "L4", "M2", "L1", "L4", "M4", "L3", "W2", "L4", "L2", "L5", "L3", "L1", "L2", "L3", "L4", "M4", "L3", "L5", "L1", "L2", "L4", "L5", "L1", "M3", "L5", "M4", "W2", "L1", "L3", "L5", "M2", "M3", "L2", "L1", "L4", "M3", "M2", "L3", "M3", "L2", "L1", "M3", "L4", "M4", "M1", "L1"],
            ["L2", "B", "L3", "L2", "M3", "L5", "L3", "M3", "L4", "L5", "L3", "L1", "L4", "M3", "L3", "L5", "B", "L2", "L4", "L3", "L1", "L5", "L2", "L4", "M3", "B", "M2", "L3", "L4", "L2", "L3", "L4", "M3", "M2", "L3", "M4", "M2", "L2", "L1", "L3", "M3", "M2", "L3", "L4", "L5", "L2", "B", "M3", "L3", "L4", "L1", "M3", "L4", "L2", "L5", "B", "L1", "L4", "M2", "L2", "L4", "L3", "L2", "M1", "B", "L3", "L5", "L4", "L1", "L2", "L4", "M3", "B", "L4", "L1", "L5", "L4", "L2", "L3", "L4", "L2", "M2", "B", "L3", "L4", "B", "M4", "L2", "L4", "M4", "L1", "L5", "M3", "M2", "L5", "L4", "M2", "M4", "M1", "L3", "B", "M4", "L3", "L4", "L5", "L3", "L4", "M3", "M2", "L4", "L3", "B", "L1", "L4", "L3", "M4", "B", "L2", "M2", "B", "L3", "L4", "L2", "M2", "L3", "L4", "M3", "L3", "L4", "M1", "M2", "L5", "L4", "M4", "M2", "M3", "L5", "L4", "L3", "L2", "B", "L1", "L4", "L3", "L1", "L4", "L3", "M2", "L1", "L4"]
        ]
    };

    WIN_RATIOS:IWinRatios = {
        normalWin : [
            {
                ratio : 0,
                text : "Tiny Win",
                duration : 0,
                type : WinRatioType.TINY
            },
            {
                ratio : 1.5,
                text : "Small Win",
                duration : 0,
                type : WinRatioType.SMALL
            },
            {
                ratio : 3,
                text : "Medium Win",
                duration : 0.4,
                type : WinRatioType.MEDIUM
            },
            {
                ratio : 5,
                text : "Large Win",
                duration : 0.8,
                type : WinRatioType.LARGE
            }],
        bigWin : [
            {
                ratio : 15,
                text : "Big Win",
                duration : 4.5,
                type : WinRatioType.BIG_WIN
            },
            {
                ratio : 25,
                text : "Mega Win",
                duration : 9.5,
                type : WinRatioType.MEGA_WIN
            },
            {
                ratio : 50,
                text : "Super Mega Win",
                duration : 14,
                type : WinRatioType.SUPER_MEGA_WIN
            }
        ]
    };

    PERFORMANCE_LOGGER:boolean = true;

    constructor() {
        if(TeslaGameConfig.instance) {
            throw new Error("TeslaGameConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}